import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { filter, Observable, timeout } from 'rxjs';
import { ShopService } from '../../../../services/shops/shop.service';
import { PLATFORM_SUPPORTS_LOCATIONS } from '../../../checkout-app/utils';
/**CHECK THIS */
@Injectable({ providedIn: 'root' })
export class CanActivateLocationRoute {
  constructor(
    private router: Router,
    private shopService: ShopService,
  ) {}

  canActivate() {
    return new Observable<boolean>((subscriber) => {
      this.shopService.shop$
        .pipe(
          filter((shop) => !!shop),
          timeout(2000),
        )
        .subscribe((shop) => {
          const supportsLocations = PLATFORM_SUPPORTS_LOCATIONS.includes(shop?.platform);
          if (supportsLocations) {
            return subscriber.next(true);
          } else {
            this.router.navigate(['/settings']);
            return subscriber.next(false);
          }
        });
    });
  }
}
